/**
 * In communication and networking, simplex and duplex refer to the direction(s) data can flow between two devices.
 * Simplex means data flows in only one direction, like a one-way street, while duplex allows data to flow in both directions.
 */
export enum GoDataDirectionType {
    Simplex = 'Simplex',
    Duplex = 'Duplex',
}

export const GoDataDirectionTypeToLabelMapping = {
    [GoDataDirectionType.Simplex]: 'Simplex',
    [GoDataDirectionType.Duplex]: 'Duplex',
};
